<template>
  <BaseModal
      :id="'static'"
      :title="title"
      :size="'lg'"
      message="Enter an Assignment Number, Description, Shift, Days per Week, and any other information. Click Save."
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                  :form_format="form_format"
                  :form_data="form_data"
                  :array_options="array_options"
                  :for_update="false"
                />
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {
  name: "FormModal",
  props: [
    "title",
    "rest_api",
    "notyf",
    "array_options",
    "breadcrumb",
  ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_data:   FormResources.form_data,
            form_format: FormResources.form_format_modal,
            form_backup: {...FormResources.form_data},
        }
    },

  watch: {
    async "form_data.associate_id"(val)
    {
      if(val && this.form_data.supervisor_id) 
      {
        if(this.array_options.supervisor_id.find(item => item.id === this.form_data.supervisor_id).associate_id  === val)
        {
            this.notyf.error(`The associate must not be the same supervisor.`);
            this.form_data.associate_id = ''
        }
      }
    },
    async "form_data.supervisor_id"(val)
    {
      if(val && this.form_data.associate_id) 
      {
        if(this.array_options.supervisor_id.find(item => item.id === val).associate_id  === this.form_data.associate_id)
        {
            this.notyf.error(`The supervisor must not be the same associate.`);
            this.form_data.supervisor_id = ''
        }
      }
    },
    "form_data.days_per_week"(val)
    {
      if (val < 0 || val > 7)
      {
        this.form_data.days_per_week = 0;
        this.notyf.error(`Error`);
      }
    },

    async 'form_data.census'(val)
    {
        if(val)
        {
            this.form_format[13].required = true
            this.form_format[13]['minlength'] = 0
        }
        else
        {
            this.form_format[13].required = false
            this.form_format[13]['minlength'] = ''
        }
    },
  },

  methods: {},

  mounted() {},
};
</script>